import { render, staticRenderFns } from "./CreateRevenueDialog.vue?vue&type=template&id=fd2f9f72&scoped=true"
import script from "./CreateRevenueDialog.vue?vue&type=script&lang=js"
export * from "./CreateRevenueDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateRevenueDialog.vue?vue&type=style&index=0&id=fd2f9f72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2f9f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd2f9f72')) {
      api.createRecord('fd2f9f72', component.options)
    } else {
      api.reload('fd2f9f72', component.options)
    }
    module.hot.accept("./CreateRevenueDialog.vue?vue&type=template&id=fd2f9f72&scoped=true", function () {
      api.rerender('fd2f9f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/dialog/CreateRevenueDialog.vue"
export default component.exports